<template>
  <div class="bar" id="bar"></div>
</template>

<script>
import echarts from "echarts";
// import china from 'echarts/map/json/china.json'
export default {
  name: "Bar",
  //接收从父组件传回的值
  props: ["getData", "show"],
  data() {
    return {
      charts: null,
    };
  },
  //实时监听父组件传过来的值，进而执行drawBar方法，重绘柱状图
  watch: {
    getData: {
      handler(value) {
        this.drawBar(value);
      },
      deep: true,
    },
    show(val, newval) {
      this.drawBar(this.getData);
    },
  },
  mounted() {
    this.drawBar();
  },
  methods: {
    drawBar({ textTitle = "", dataType = "", dataArray = [] } = {}) {
      this.charts = echarts.init(this.$el);
      // 会出问题
      // let barBox = this.$echarts.init(document.getElementById("bar"));
      let bar = document.getElementById("bar");
      let echart_width = bar.offsetWidth;
      let echart_height = bar.offsetHeight;
      let option = {
        title: {
          text: textTitle,
          left: "center",
          top: 20,
          textStyle: {
            color: "#000",
          },
        },
        //图例，每个图表最多仅有一个图例
        legend: {
          // 图例内边距，单位px，默认上下左右内边距为5
          padding: 10,
          // Legend各个item之间的间隔，横向布局时为水平间隔，纵向布局时为纵向间隔
          itemGap: 10,
          //显示策略，可选为：true（显示） | false（隐藏），默认值为true
          show: true,
          //水平安放位置，默认为全图居中，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
          x: "center",
          //垂直安放位置，默认为全图顶端，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
          y: "top",
          // //legend的data: 用于设置图例，data内的字符串数组需要与sereis数组内每一个series的name值对应
          // data: ['数量','金额'],
          // selected: {
          //     // 选中---'数量'
          //     '数量': true,
          //     // 不选中---'金额'
          //     '金额': false
          // }
        },
        grid: {
          top: 80,
        },
        //工具箱，每个图表最多仅有一个工具箱
        toolbox: {
          //显示策略，可选为：true（显示） | false（隐藏），默认值为false
          show: true,
          //启用功能，目前支持feature，工具箱自定义功能回调处理
          feature: {
            //辅助线标志
            mark: { show: true },
            // //dataZoom，框选区域缩放，自动与存在的dataZoom控件同步，分别是启用，缩放后退
            // dataZoom: {
            //     show: true,
            //     title: {
            //         dataZoom: '区域缩放',
            //         dataZoomReset: '区域缩放后退'
            //     }
            // },
            //数据视图，打开数据视图，可设置更多属性,readOnly 默认数据视图为只读(即值为true)，可指定readOnly为false打开编辑功能
            dataView: { show: false, readOnly: true },
            //magicType，动态类型切换，支持直角系下的折线图、柱状图、堆积、平铺转换
            magicType: { show: true, type: ["line", "bar"] },
            //restore，还原，复位原始图表
            restore: { show: true },
            //saveAsImage，保存图片（IE8-不支持）,图片类型默认为'png'
            saveAsImage: { show: true },
          },
        },
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          // data: dataArray,
        },
        yAxis: { type: "category" },
        dataset: {
          // 提供一份数据。
          source: dataArray,
        },
        series: [
          {
            // 颜色盘
            color: ["#639bdf"],
            //图表类型，必要参数！如为空或不支持类型，则该系列数据不被显示。
            type: "bar",
            // // 柱状图上方显示数值
            // label:{
            //     show:true,
            //     position:'right',
            //     color:'#639bdf',
            //     formatter:'{c}',
            // },
            encode: {
              // 将 "amount" 列映射到 X 轴。
              x: dataType,
              // 将 "product" 列映射到 Y 轴。
              y: "FullName",
            },
          },
        ],
      };
      this.charts.setOption(option, true);
      this.charts.resize(echart_width, echart_height);
      // 会出问题
      // barBox.setOption(option, true);
      // 重置图标宽高
      // barBox.resize(echart_width,echart_height);
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Common/LineEchart/LineEchart.vue